export default __webpack_public_path__ + "img/landscape_3.a8fe217e3cacd6aacdae20e96081cf7a.jpg";